import { defineComponent as _defineComponent } from 'vue'
import {t} from "@/mixin/mixins";
  import ModalDialog from "@/components/ModalDialog.vue";
  import {computed, reactive, watch} from "vue";
  import useVuelidate from "@vuelidate/core";
  import {required, integer, minValue} from "@vuelidate/validators";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PlanOrderDialog',
  props: {
    isVisible: {
      type: Boolean,
      default: () => false
    },
    positions: {
      type: Number,
      default: () => 0
    }
  },
  emits: ["save", "close"],
  setup(__props, { emit }) {

const props = __props

  const errors = computed(() => {
    const map = new Map<string, string>();
    // @ts-ignore
    v$.value.$errors.forEach(error => map.set(error.$property, error.$message as string));
    return map;
  });

  

  const initialState = {
    positions: 0
  };

  const state = reactive({...initialState});

  const isVisible = computed({
    get: () => props.isVisible,
    set: () => { }
  });

  watch(() => props.isVisible, () => {
    state.positions = props.positions ? props.positions : 0;
  });

  

  const rules = {
    positions: {
      required,
      integer,
      minValue: minValue(1)
    }
  };

  const v$ = useVuelidate(rules, state);

  const save = () => {
    v$.value.$reset();
    v$.value.$touch();

    if (!v$.value.$invalid && state.positions) {
      emit("save", state.positions);
    }
  };

  const close = () => {
    emit("close");
  };

return { __sfc: true,errors, props, initialState, state, isVisible, emit, rules, v$, save, close, t, ModalDialog }
}

})